export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[500px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dynamic%20geometric%20composition%20with%20warm%20coral%20red%20and%20golden%20amber%20gradients%2C%20fluid%20flowing%20shapes%20suggesting%20movement%20and%20energy%2C%20modern%20minimalist%20design%2C%20soft%20gradient%20transitions%2C%20cinematic%20lighting%2C%20clean%20elegant%20abstract%20background%2C%20subtle%20texture%2C%20professional%20grade%20visual&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="每日大赛入口背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 mb-5 whitespace-nowrap">
              每日更新 · 高清流畅 · 免费观看
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              每日大赛入口 — 热门赛事高清视频在线观看平台
            </h1>

            <p className="text-sm md:text-base text-white/80 mb-3 font-medium">
              汇聚全球精彩赛事，随时随地畅享竞技魅力
            </p>

            <p className="text-xs md:text-sm text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              每日大赛入口是国内领先的赛事视频聚合平台，专注为竞技爱好者提供篮球、足球、电竞、音乐综艺、舞蹈竞技等全品类大赛视频。每日更新最新赛事回放、精彩集锦和全场录像，每日大赛免费观看，无需注册即可在线播放高清内容。当前站内篮球赛事、电竞赛事、音乐综艺三大板块热度持续攀升，NBA夏季联赛和LPL夏季赛相关内容更新最为活跃。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-7">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-white">15万+</div>
                <div className="text-xs text-white/55">赛事视频资源</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-white">每日更新</div>
                <div className="text-xs text-white/55">最新比赛回放</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-white">完全免费</div>
                <div className="text-xs text-white/55">高清流畅播放</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                探索热门话题
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-colors border border-white/25 whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                查看精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20and%20competition%20collage%20featuring%20basketball%20dunk%20silhouette%20and%20esports%20gaming%20stage%20with%20colorful%20lights%2C%20warm%20coral%20and%20golden%20amber%20gradient%20overlay%2C%20modern%20cinematic%20composition%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20spotlight%20effects&width=900&height=700&seq=hero-visual-main&orientation=landscape"
                alt="每日大赛入口 - 热门赛事视频在线观看"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}